export default {
  methods: {
    invoiceStatusColour (status) {
      switch (status) {
        case 'PAID': return 'green-7'
        case 'PARTIAL': return 'teal'
        case 'DRAFT': return 'grey'
        case 'ARCHIVED': return 'grey-6'
        default:
        case 'OPEN': return 'orange-8'
      }
    },
    invoiceStatusName (status) {
      switch (status) {
        case 'PAID': return 'Paid'
        case 'PARTIAL': return 'Partial Paid'
        case 'DRAFT': return 'Draft'
        case 'ARCHIVED': return 'Archived'
        default:
        case 'OPEN': return 'Unpaid'
      }
    },
    invoiceStatusOptions (withAll = false, colorKey = 'color') {
      const arr = [
        { label: 'Draft', value: 'DRAFT', [colorKey]: 'grey' },
        { label: 'Unpaid', value: 'OPEN', [colorKey]: 'orange-8' },
        { label: 'Partial Paid', value: 'PARTIAL', [colorKey]: 'teal' },
        { label: 'Paid', value: 'PAID', [colorKey]: 'green' }
      ]
      if (withAll) {
        arr.unshift({ value: null, label: 'All Invoices' })
      }
      return arr
    },
    availableInvoiceStatuses () {
      return this.invoiceStatusOptions().filter(item => ['DRAFT', 'OPEN'].includes(item.value))
    },
    overdueDaysStr (invoice) {
      if (invoice.overdue_paid_days > 0) {
        return `Paid ${invoice.overdue_paid_days} ${this.pluraliseString('day', invoice.overdue_paid_days)} late`
      }

      return `${invoice.overdue_days} ${this.pluraliseString('day', invoice.overdue_days)} overdue`
    },
    invoiceTermStr (invoice) {
      return `${invoice.due_days} day term`
    }
  }
}
